/* eslint-disable jsx-a11y/anchor-is-valid */

import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NavLinks from "./NavLinks";
import SideDrawer from "./SideDrawer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { handleNavLinksOnHeader } from "slices/global";
import { getUserProfile } from "slices/userReducer";
import { getAuth } from "firebase/auth";
import { setIsLoginData } from "slices/authReducers";
import LogoutConfirmation from "./LogoutConfirmation";
import NavIcons from "./NavIcons";
import { ROUTES } from "constants/routes";

function Header(props: any) {
  const { isMobileView, showHeader } = props;
  const { authReducer, userReducer, globalReducer }: any = useAppSelector(
    (state) => state
  );

  const {
    isLoggedIn,
    verifyingOtp,
    loginState,
    isLoadingAuth,
    isSubmitting,
    otpVerification,
  }: any = authReducer;
  const { displayName, pic, email } = loginState;
  const { showNavLinksOnHeader } = globalReducer;
  const dispatch = useAppDispatch();
  const [showDrawer, setShowDrawer] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [showDialog, setShowDialog] = React.useState(false);
  const { pathname } = location;

  React.useEffect(() => {
    if (pathname?.includes("list-equipment")) {
      dispatch(handleNavLinksOnHeader(false));
    } else {
      dispatch(handleNavLinksOnHeader(true));
    }

    if (["/", "/about-us", "/how-it-works", "/faq", ""]?.includes(pathname)) {
      (window as any)?.tidioChatApi?.show();
      (window as any)?.tidioChatApi?.close();
    } else {
      (window as any)?.tidioChatApi?.hide();
      (window as any)?.tidioChatApi?.close();
    }
  }, [pathname]);

  React.useEffect(() => {
    if (isLoggedIn && !isSubmitting && !otpVerification && !isLoadingAuth) {
      // alert("Header:  Logged : " + isLoggedIn + " - submit - "+ isSubmitting)
      // dispatch(getUserProfile());
      // alert("called from Header");
    }
  }, [dispatch, isLoggedIn, isSubmitting, otpVerification]);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setShowDrawer(true);
  };

  const isMobileHeaderWithoutLogin: boolean =
    isMobileView &&
    (!isLoggedIn || verifyingOtp) &&
    [
      ROUTES.SIGNIN,
      ROUTES.SIGNUP,
      ROUTES.FORGOT_PASSWORD,
      "/reset-password",
    ]?.includes(pathname);
  const menuBtnIconColor: any = isMobileHeaderWithoutLogin ? "#fff" : "primary";
  React.useEffect(() => {
    async function fetchUser() {
      if (!displayName && isLoggedIn && !isLoadingAuth) {
        const auth = await getAuth();
        const user: any = await auth.currentUser;

        const payload = {
          displayName: user?.displayName,
          email: user?.email,
          pic: user?.photoURL,
        };
        dispatch(setIsLoginData(payload));
      }
    }
    fetchUser();
  }, [displayName]);
  return showHeader ? (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: isMobileHeaderWithoutLogin
          ? "primary.main"
          : "common.white",
        borderRadius: 0,
        borderBottom: "1px solid #E2E2E2",
        ...(!isMobileHeaderWithoutLogin && {
          // background: `url(${require("assets/img/png/bgCurves.png")})`,
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "auto",
          backgroundColor: "#fff",
          zIndex: 3,
        }),
      }}
      elevation={0}
    >
      <LogoutConfirmation
        showDialog={showDialog}
        setShowDialog={setShowDialog}
      />
      <Container maxWidth={false} style={{ paddingRight: "0px" }}>
        <Toolbar disableGutters>
          {/* <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} /> */}
          <img
            src={require(`assets/img/png/${
              isMobileHeaderWithoutLogin ? "Logo_new.png" : "header_logo1.png"
            }`)}
            className="logo"
            style={{
              margin: "auto 0",
              alignSelf: "flex-start",
              cursor: "pointer",
              width: "122px",
              height: "39px",
            }}
            alt=""
            onClick={() => navigate("/")}
          />
          {/* <img src={require("assets/img/png/bgCurves.png")}/> */}
          <SideDrawer
            setShowDialog={setShowDialog}
            showDrawer={showDrawer}
            setShowDrawer={setShowDrawer}
          />

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <NavIcons />
            <IconButton
              size="large"
              aria-label="Open MEnu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color={menuBtnIconColor}
            >
              <MenuIcon />
            </IconButton>
          </Box>
          {showNavLinksOnHeader && <NavLinks setShowDialog={setShowDialog} />}
        </Toolbar>
      </Container>
    </AppBar>
  ) : null;
}
export default Header;
